import { useTranslation } from "react-i18next";
import ReplayPlayIcon from "../../../../assets/icons/replay-play.svg";
import ChevronRightIcon from "../../../../assets/icons/grey-chevron-right.svg";
import "./HighlightMomentItem.less";

interface HighlightMomentItemProps {
  thumbnail: string;
  number: number;
  watched: boolean;
  duration: string;
  time?: string | number;
  onClick?: () => void;
}

const HighlightMomentItem: React.FC<HighlightMomentItemProps> = ({ thumbnail, number, watched, duration, time, onClick }) => {
  const { t } = useTranslation();

  const formatTime = (seconds: string | number) => {
    const secs = typeof seconds === "string" ? parseFloat(seconds) : seconds;
    const mins = Math.floor(secs / 60);
    const remainingSecs = Math.floor(secs % 60);
    return `${mins}:${remainingSecs.toString().padStart(2, "0")}`;
  };

  return (
    <div className="highlight-moment-item" onClick={onClick} style={{ cursor: onClick ? "pointer" : "default" }}>
      <div className="moment-thumbnail-container">
        <div className="moment-thumbnail" style={{ backgroundImage: `url(${thumbnail})` }}>
          <img src={ReplayPlayIcon} alt="play" className="play-icon" />
        </div>
        {watched && <div className="watched-indicator" />}
      </div>
      <div className="moment-info">
        <div className="moment-status">
          {number}. {watched ? t("already-watched") : t("to-watch")}
        </div>
        <div className="moment-duration">{duration}</div>
        {time && <div className="moment-time">{formatTime(time)}</div>}
      </div>
      <img src={ChevronRightIcon} alt="chevron" className="chevron-icon" />
    </div>
  );
};

export default HighlightMomentItem;
